import { FormChild } from "@/v1/components/atoms/FormChild";
import { QuerySelect } from "@/v2/components/organisms/QuerySelect/QuerySelect";
import { useTranslation } from "@/v2/hooks/useTranslation";
import { useOperatorsSelectParams } from "@/v2/query/useOperatorsSelectQuery/useOperatorsSelectParams";
import { useOperatorsSelectQuery } from "@/v2/query/useOperatorsSelectQuery/useOperatorsSelectQuery";
import { getGenericRequiredErrorV2 } from "@/v2/utils/getGenericRequiredError";

export const NewsletterOperatorsSelect = () => {
  const { t } = useTranslation();
  return (
    <FormChild>
      <QuerySelect
        name="operatorId"
        label={t("label.operator")}
        placeholder={t("placeholder.operator")}
        errors={getGenericRequiredErrorV2(t)}
        useQuery={useOperatorsSelectQuery}
        useQueryParams={useOperatorsSelectParams}
      />
    </FormChild>
  );
};
